export enum BankAccountTypeEnum {
	UNKNOWN = "Unknown",
	PRIMARY = "Primary",
	SECONDARY = "Secondary"
}
